import { backgroundToTextColor } from '@klv/shared/styles/utils';
import relatedContentCard from '@klv/molecules/related-content-card/themes/default';

import type { IButton } from '@klv/atoms/button/types';
import type { ICreateButtonsArray, ISetButtonColor, ISetTextHoverColor } from '../types';

export const createButtonsArray = ({ buttons = [], url = '' }: ICreateButtonsArray) => {
  if (buttons?.length) {
    return buttons.map((button: IButton) => ({ text: button.text, openInNewTab: button.openInNewTab, url }));
  }

  return buttons;
};

export const setButtonColor = ({
  hasHoverImage, isHovered, solidCardHoverColor, variant,
}: ISetButtonColor) => {
  if (hasHoverImage && isHovered) {
    return 'light';
  } if (solidCardHoverColor === 'none') {
    return isHovered ? relatedContentCard[variant].buttonHoverColor : relatedContentCard[variant].buttonColor;
  } if (isHovered) {
    return backgroundToTextColor[solidCardHoverColor as keyof typeof backgroundToTextColor] === 'charcoal' ? 'dark' : 'light';
  } if (variant === 'light') {
    return 'dark';
  }

  return 'light';
};

export const setTextHoverColor = ({
  $hasImage, $solidCardHoverColor, $variant,
}: ISetTextHoverColor) => {
  if (!$hasImage && $solidCardHoverColor === 'none') {
    return relatedContentCard[$variant].defaultTextHover;
  }

  if (!$hasImage && $solidCardHoverColor !== 'none') {
    return backgroundToTextColor[$solidCardHoverColor as keyof typeof backgroundToTextColor];
  }

  if ($hasImage) {
    return relatedContentCard[$variant].imageTextHover;
  }

  return '';
};
